export const getEnv = (name: string): string => {
    const val = process.env[name];
    if (val == null)
        throw new TypeError(`process.env[${JSON.stringify(name)}] is null or undefined`);
    return val;
};
